import { createStoreCreator } from 'lib/store'
import reducer from 'measurements/reducers'

export default createStoreCreator(reducer)
